import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { sufficientInsuranceDataToDisplayInsuranceCard } from '../../../../../core/util/insurance';
import { TYPE_INSURANCE, SOURCE_BOOKING_WIDGET } from '../../../../../constants/index';
import { isEmptyArray } from '../../../../../core/util/array';
import { getDisplayableUserProfilesInAccountSummary } from '../../../../../core/util/account';
import Selector from '../../../../UserProfileSelector';
import { biggerThan, smallerThanOrEqualTo } from '../../../../../core/util/styledComponents';
import { colors } from '../../../../../constants/colors';
import InsuranceMiniCard from '../../../components/InsuranceMiniCard';
import { useBookingWidgetIsFamilyBooking } from '~/hooks/redux/useBookingWidgetFamilyBookingData';

const StyledUserProfileSelector = styled(Selector).withConfig({ componentId: 'sc-1cyk5qu-0' })`
  z-index: 10;
  background-color: ${colors.white};
  span[class='Select-arrow-zone'] {
    width: 0 !important;
    padding-right: 0 !important;
  }
  margin: 0 15px;
`;

const UserInfoTitle = styled.div.withConfig({ componentId: 'sc-1cyk5qu-1' })`
  display: flex;
  justify-content: space-between;
  margin: 0 10px 10px 20px;
`;

const SectionTitle = styled.div.withConfig({ componentId: 'sc-1cyk5qu-2' })`
  display: flex;
  justify-content: space-between;
  ${smallerThanOrEqualTo.md`
    margin: 0 10px 10px 20px;
  `};
  ${biggerThan.md`
    margin: 0 4px;
  `};
`;

const FormUserInfoBlock = styled.div.withConfig({ componentId: 'sc-1cyk5qu-3' })`
  margin-bottom: 20px;
  background-color: ${colors.white};
`;

type Props = {
  isLoggedIn: boolean;
  accountSummary?: any;
  onChangeOfUserProfile: (...args: any[]) => any;
  form: any;
  location: any;
  insuranceProfile?: any;
  handleReplaceInsurance: (...args: any[]) => any;
  payment: any;
  getAddressFields: (...args: any[]) => any;
  initialValues: any;
};

const UserProfileSelector = (props: Props) => {
  const {
    isLoggedIn,
    accountSummary,
    onChangeOfUserProfile,
    insuranceProfile,
    payment,
    handleReplaceInsurance,
    initialValues,
    location,
    form,
    getAddressFields,
  } = props;
  const { t } = useTranslation('bookingWidget');
  const isFamilyVisitActivatedInBookingWidget = useBookingWidgetIsFamilyBooking();

  if (!isLoggedIn || isEmptyArray(getDisplayableUserProfilesInAccountSummary(accountSummary))) {
    return null;
  }

  return (
    <div>
      <UserInfoTitle>
        <SectionTitle>
          {isFamilyVisitActivatedInBookingWidget
            ? `${t('userProfileAndPatientInfo.title')} #1`
            : t('userProfileAndPatientInfo.whoIsThisAppointmentFor')}
        </SectionTitle>
      </UserInfoTitle>

      <StyledUserProfileSelector
        accountSummary={accountSummary}
        handleChangeUserProfile={onChangeOfUserProfile}
        source={SOURCE_BOOKING_WIDGET}
      />

      <FormUserInfoBlock>
        {insuranceProfile &&
          sufficientInsuranceDataToDisplayInsuranceCard(insuranceProfile) &&
          payment.value === TYPE_INSURANCE && (
            <div>
              <hr />

              <InsuranceMiniCard
                dateOfBirth={insuranceProfile.birth_date}
                firstName={insuranceProfile.first_name}
                handleReplaceInsurance={handleReplaceInsurance}
                insuranceCarrierName={insuranceProfile.insurer_name}
                insurerType={insuranceProfile.insurer_type}
                lastName={insuranceProfile.last_name}
                memberId={insuranceProfile.member_code}
              />
            </div>
          )}
      </FormUserInfoBlock>
    </div>
  );
};

export default UserProfileSelector;
